import { GridCellParams } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { GridCustomColDef } from '../../../../types';
import {
  advancedDatePickerOperator,
  advancedEnumOperators,
  advancedNumericOperators,
  advancedOperators
} from '../../../../Compounds/UpstackDataGrid/helpers';
import { DetailCTARenderer } from '../../../../Compounds/UpstackDataGrid/CellRenderers';
import { ComponentName, getMetaData } from '../../../../Compounds/DetailsDrawer/detailsDrawersHelpers';
import { getFormattedDate, getDate, numberValueFormatter } from '../../../../../utils/helpers';
import { AuditStatus, AuditType } from '../../../../../store/RunTotalAudit';

export const DefaultRunTotalAuditGridColumnDefs: GridCustomColDef[] = [
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.RUN_TOTAL_AUDIT, id: params.row.id, data: params.row })
        }}
      />
    ),
    hideable: false,
    pinned: 'left',
    disableReorder: true
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'createdAt',
    headerName: 'Created At',
    sortable: true,
    filterable: true,
    width: 170,
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    valueGetter: (value) => {
      return value ? getDate(value).getTime() : null;
    },
    description: 'Drag to move column',
    filterOperators: advancedDatePickerOperator()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'createdBy.email',
    headerName: 'Created By',
    sortable: false,
    filterable: true,
    width: 170,
    renderCell: (params: GridCellParams) => (
      <span title={params.row.createdBy?.email || ''}>{params.value as string}</span>
    ),
    valueGetter: (_value, row) => `${row?.createdBy?.firstName || ''} ${row?.createdBy?.lastName || ''}`,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: Object.values(AuditStatus ?? {}),
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'status',
    headerName: 'Status',
    sortable: true,
    filterable: true,
    width: 200,
    description: 'Drag to move column',
    filterOperators: advancedEnumOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: Object.values(AuditType ?? {}),
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'auditType',
    headerName: 'Type',
    sortable: true,
    filterable: true,
    width: 150,
    description: 'Drag to move column',
    filterOperators: advancedEnumOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'beforeSnapshotTimestamp',
    headerName: 'Before',
    sortable: true,
    filterable: true,
    width: 170,
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    valueGetter: (value) => {
      return value ? getDate(value).getTime() : null;
    },
    description: 'Drag to move column',
    filterOperators: advancedDatePickerOperator()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'afterSnapshotTimestamp',
    headerName: 'After',
    sortable: true,
    filterable: true,
    width: 170,
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    valueGetter: (value) => {
      return value ? getDate(value).getTime() : null;
    },
    description: 'Drag to move column',
    filterOperators: advancedDatePickerOperator()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'completedAt',
    headerName: 'Completed At',
    sortable: true,
    filterable: true,
    width: 170,
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    valueGetter: (value) => {
      return value ? getDate(value).getTime() : null;
    },
    description: 'Drag to move column',
    filterOperators: advancedDatePickerOperator()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'allTablesTotalRowsBefore',
    headerName: 'Total Before',
    sortable: true,
    filterable: true,
    width: 150,
    description: 'Drag to move column',
    valueFormatter: (value) => numberValueFormatter(value),
    filterOperators: advancedNumericOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'allTablesTotalRowsAfter',
    headerName: 'Total After',
    sortable: true,
    filterable: true,
    width: 150,
    description: 'Drag to move column',
    valueFormatter: (value) => numberValueFormatter(value),
    filterOperators: advancedNumericOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'allTablesRowsUpdated',
    headerName: 'Total Changed',
    sortable: true,
    filterable: true,
    width: 150,
    description: 'Drag to move column',
    valueFormatter: (value) => numberValueFormatter(value),
    filterOperators: advancedNumericOperators()
  }
];
